import { VisibilityRecurrenceScheduleEvaluator } from './visibility-recurrence.evaluator';
import { VisibilityRecurrenceSchedulePayload } from './visibility-recurrence.models';

const evaluator = new VisibilityRecurrenceScheduleEvaluator();

function isSchedulePayload(value: unknown): value is VisibilityRecurrenceSchedulePayload {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const o = value as VisibilityRecurrenceSchedulePayload;
  return Array.isArray(o.rules);
}

/**
 * Eval entry point for visibility expressions (inject next to `time` in the web runtime).
 */
export function visibilityRecurrenceMatches(payload: unknown, time: Date): boolean {
  if (!(time instanceof Date) || Number.isNaN(time.getTime())) {
    return false;
  }
  if (!isSchedulePayload(payload)) {
    return false;
  }
  return evaluator.matches(time, payload);
}

/**
 * Returns true when `at` falls on a recurrence occurrence day (marketplace calendar) and
 * lies within at least one time slot of any rule (OR across rules).
 * Prefer this for app code and unit tests; use {@link visibilityRecurrenceMatches} for expression runtime.
 */
export function matchesRecurrenceScheduleAt(
  at: Date,
  schedule: VisibilityRecurrenceSchedulePayload,
): boolean {
  return visibilityRecurrenceMatches(schedule, at);
}

export { VisibilityRecurrenceScheduleEvaluator } from './visibility-recurrence.evaluator';
export type {
  VisibilityRecurrenceRulePayload,
  VisibilityRecurrenceSchedulePayload,
} from './visibility-recurrence.models';
